module.exports = __webpack_public_path__ + "static/media/icon-del.46a93617.svg";